import MapRightContainer from "../../../components/property/map/MapRight";

const MapRight = () => {
  return <MapRightContainer />;
};

export default MapRight;
